export const eu = require("./eu.png");
export const cn = require("./cn.png");



// WEBPACK FOOTER //
// ./src/assets/images/flags/index.js